/**
 * Shared React Query client singleton.
 *
 * Extracted from main.tsx so non-component modules — notably the auth store —
 * can import the *same* instance. The auth store clears this cache on every
 * auth transition (login / MFA / logout) so one user's cached data can never
 * bleed into the next session (e.g. a prior admin's security dashboard being
 * served to a lower-tier user who logs in next in the same tab).
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
